export default __webpack_public_path__ + "static/media/IMG_20210802_011127_272.8f84e510.jpg";